/**
 * British English translation for bootstrap-datepicker
 * Xavier Dutreilh <xavier@dutreilh.com>
 */
;(function($){
  $.fn.datepicker.dates['en'].format = "m/d/yyyy"
}(jQuery));